<template>
    <div class="relative inline-block" ref="dropdownContainer">
        <button
            @click="toggleDropdown"
            class="p-2 flex items-center justify-between gap-1 rounded-md border border-gray-400 bg-white hover:bg-gray-200 text-black"
            :class="[sizeStyles, { 'bg-gray-200': isOpen }, buttonClass]"
            type="button"
        >
            <slot name="trigger"></slot>
            <font-awesome :icon="dropdownIcon" class="w-4 h-4" :class="{ 'rotate-180': isOpen }" />
        </button>

        <div
            v-if="isOpen"
            class="absolute z-50 min-w-full w-52 mt-1 px-2 py-4 bg-white border border-gray-400 rounded-md shadow-lg"
            :class="[
                position === 'top' ? 'bottom-full mb-1' : 'top-full mt-1',
                alignment === 'right' ? 'right-0' : 'left-0'
            ]"
        >
            <slot></slot>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';

const props = defineProps({
    size: {
        type: String,
        default: 'normal',
        validator: (value) => ['xxs', 'xs', 'small', 'normal', 'large'].includes(value)
    },
    position: {
        type: String,
        default: 'bottom',
        validator: (value) => ['top', 'bottom'].includes(value)
    },
    alignment: {
        type: String,
        default: 'left',
        validator: (value) => ['left', 'right'].includes(value)
    },
    buttonClass: {
        type: String,
        default: ''
    },
    dropdownIcon: {
        type: Array,
        default: ['fas', 'angle-down']
    }
});

const isOpen = ref(false);
const dropdownContainer = ref(null);

const toggleDropdown = () => {
    isOpen.value = !isOpen.value;
};

const closeDropdown = (event) => {
    if (dropdownContainer.value && !dropdownContainer.value.contains(event.target)) {
        isOpen.value = false;
    }
};

onMounted(() => {
    document.addEventListener('click', closeDropdown);
});

onUnmounted(() => {
    document.removeEventListener('click', closeDropdown);
});

const sizeStyles = computed(() => ({
    xxs: 'px-1 py-1 text-sm min-h-[24px]',
    xs: 'px-2 py-1 text-sm min-h-[32px]',
    small: 'px-2 py-1 text-sm min-h-[42px]',
    normal: 'p-2 text-base min-h-[42px] w-full',
    large: 'px-5 text-xl gap-3 w-full'
}[props.size || 'normal']));
</script>
